import React, { Component } from 'react'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'
import StrapiImage from "../components/StrapiImage.js"
import Layout from '../components/layout'
import ReactMarkdown from "react-markdown"
import ArticleContent from "../components/articleContent"
import Contact from "../components/contact_article"
import NewSection from '../components/sectionnew'

import HomeBut from "../components/HomeBut.js"
import {returnImage} from '../actions/utils.js'


import ContactObject from "../components/contactobject"


import BackgroundImage from 'gatsby-background-image'
import Nav from '../components/nav'
import { StickyContainer, Sticky } from 'react-sticky';

import '../../node_modules/react-vis/dist/style.css';

export default class ArticlesTemplate extends Component {
  constructor(props) {
    super(props)

    this.layoutContents = React.createRef()
    this.layoutWrapper = React.createRef()

  }




  render() {

    return (



<StickyContainer className="container">

<Layout
  theme="article"
  metaName={`${this.props.data.strapiProjects.Project_name}`}
  metaDescription={`${this.props.data.strapiProjects.Project_location}`}
  metaImage={`${this.props.data.strapiProjects.Project_image.childImageSharp.fixed.src}`}
>

<section  ref={n => (this.layoutWrapper = n)}>


  <div ref={n => (this.layoutContents = n)}>
  <Sticky>
  {({ style,isSticky,
      wasSticky, }) => (
  <nav className="SubSticky" style={{backgroundColor:this.props.data.allStrapiMicrosites.edges[0].node.MainColor}}>

  <Nav sections={ this.props.data.allStrapiMicrosites.edges[0].node.Content} backgroundColor={this.props.data.allStrapiMicrosites.edges[0].node.MainColor} textColour={this.props.data.allStrapiMicrosites.edges[0].node.MenuTextColor} hightlightColor={this.props.data.allStrapiMicrosites.edges[0].node.secondColor} handleShow={this.handleShow}  isSticky={isSticky}/>
  </nav>
  )}
  </Sticky>

<article id="article" className="content" itemScope itemType="https://schema.org/Article">
    <div itemProp="publisher" itemScope itemType="https://schema.org/Organization">
        <meta itemProp="name" content="AECOM"/>
    </div>

    <div className="content__main">
<header className="content__header project">


            <div className="article-container">
              <Link className="homebutton" to="/"><HomeBut color={this.props.data.allStrapiMicrosites.edges[0].node.HeaderBackgroundColour} /></Link>
                <div className="content__headline-wrapper">

                    <h1 className="content__headline" itemProp="headline" style={{color:this.props.data.allStrapiMicrosites.edges[0].node.HeaderBackgroundColour}}>{this.props.data.strapiProjects.Project_name}</h1>
                    <h2><span style={{color:this.props.data.allStrapiMicrosites.edges[0].node.HeaderBackgroundColour}}>{this.props.data.strapiProjects.Project_location}</span></h2>
                </div>
            </div>
        <BackgroundImage Tag="div" className="Project_header_image" fluid={returnImage(this.props.data.strapiProjects.Project_image,this.props.data.allStrapiMicrosites.edges[0].node.HeaderBackgroundColour,this.props.data.allStrapiMicrosites.edges[0].node.overlayOpacity)}>
<div className="article-container" style={{color:this.props.data.allStrapiMicrosites.edges[0].node.HeaderTitleColour }}>
<ContactObject data={this.props.data.strapiProjects.contacts} color={this.props.data.allStrapiMicrosites.edges[0].node.HeaderTitleColour}/>

</div>
        </BackgroundImage>
        </header>

        <div className="article-container">
          <div className="content__main-column">

          <div className="content__article-body" itemProp="articleBody"style={{color:this.props.data.allStrapiMicrosites.edges[0].node.textColor}} >
              {this.props.data.strapiProjects.Content.map((document, index) => (
                  <ArticleContent data={document} key={index} Homepage={false} Color={this.props.data.allStrapiMicrosites.edges[0].node} />
              ))}

        </div>

        </div>
        <div className="content__secondary-column">
{this.props.data.allStrapiMicrosites.edges[0].node.pardot_form  !== null ?
        <Contact data={this.props.data.allStrapiMicrosites.edges[0].node} AltDownload={this.props.data.strapiProjects.Download} AltImage={this.props.data.strapiProjects.Download_preview} altTitle={this.props.data.strapiProjects.title} altMessage={this.props.data.strapiProjects.Download_message}/>
:<></>}


        </div>
        </div>
        </div>
        </article>
        {this.props.data.strapiProjects.related_content !== null ?
          <div ref={this.props.data.strapiProjects.related_content.Title}>
            <NewSection data={this.props.data.strapiProjects.related_content} MainColour={this.props.data.allStrapiMicrosites.edges[0].node.MainColor} secondColor={this.props.data.allStrapiMicrosites.edges[0].node.secondColor} textColor={this.props.data.allStrapiMicrosites.edges[0].node.textColor} />
          </div>
:<></>}
        </div>

    </section>


    </Layout>
      </StickyContainer>

)
}
}

export const query = graphql`
  query ProjectsTemplate($slug: String!,$MicrositeIDFull: String!) {
    strapiProjects(slug: {eq:$slug}) {
      Project_content
      Project_location
      wistiaID
      playerColour
      Project_name
      services
      contacts {
        email
        showBioPage
        name
        slug
        Social
        position
        image {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 80) {
              base64
              tracedSVG
              aspectRatio
              src
              srcSet
              srcWebp
              srcSetWebp
              sizes
              originalImg
              originalName
              presentationWidth
              presentationHeight
             }
          }
        }
      }

      Project_image {
        absolutePath
        publicURL
        childImageSharp {
          fixed(width: 500) {
             base64
             tracedSVG
             aspectRatio
             width
             height
             src
             srcSet
             srcWebp
             srcSetWebp
             originalName
           }
        fluid (maxWidth: 6000, quality: 100){
          base64
          tracedSVG
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
          originalImg
          originalName
          presentationWidth
          presentationHeight
        }
      }
      }
      slug
      Content {
            Content
            Type
            caption
            Type
            wistia_id
            mp3 {
                publicURL
              }
              teaser
              title
            color
            inline
            size
            position
            Image {
              childImageSharp {
                  fluid (maxWidth: 6000, quality: 100){
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                  presentationWidth
                  presentationHeight
                }
              }

            }
            graph {
              Data {
                Color
                Type
                title
                Json_data
                Data {
                  x
                  y
                }
                angle
                color
                Label
                sublabel
              }
              Type
              Xaxis
              Yaxis
              title
              caption
            }
            BackgroundColour
            TextColour
            Title
            TitleColour
            text
                  DisplayType
                  TileBackgroundColour
                  TileTextColour
                  TileborderColour
                  Tile_text_pacement
                  overlayOpacity
                  Type
                  AccordianTextColour
                  AccordianTitleColour
                  buttontext
                  background {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              srcWebp
                              srcSetWebp
                              originalImg
                              originalName
                          }
                      }
                  }
                  link
                  items_per_column
                  column_item {
                    id
                     text
                     title
                     link
                     link_text
                    image {
                      childImageSharp {
                         fluid {
                           base64
                           tracedSVG
                           aspectRatio
                           src
                           srcSet
                           srcWebp
                           srcSetWebp
                           sizes
                           originalImg
                           originalName
                           presentationWidth
                           presentationHeight
                          }
                        }
                      publicURL
                      extension
                    }
                  }

                  accordian_item {
                      Title
                      Content
                      microsites {
                          site_name
                          slug

                      }
                      events {
                          Event_name
                          slug
                      }
                      contacts {
                          name
                          email
                          showBioPage
                          slug
                      }
                      podcasts {
                          title
                          id
                      }
                      projects {
                          slug
                          Project_name
                      }
                      services {
                          slug
                          service_name
                      }
                      videos {
                          title
                          Player_colour
                          wisita_id
                      }
                      withoutlimits {
                          slug
                          title
                      }
                      articles {
                          slug
                          type
                          title
                      }
                      links {
                          subtitle
                          title
                          url
                      }
                  }

                  links {
                      image {
                          childImageSharp {
                              fluid(maxWidth: 6000, quality: 100){
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      id
                      subtitle
                      title
                      url
                  }
                  microsites {
                      Header_background {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  srcWebp
                                  srcSetWebp
                                  originalImg
                                  originalName
                              }
                          }
                      }
                      logo {
                          publicURL
                          extension
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      site_name
                      site_intro
                      createdAt
                      slug
                  }

                  podcasts {
                      id
                      podcastid
                      podcasturl
                      title
                  }
                  events {
                      Event_name
                      date(formatString: "MMMM D, YYYY")
                      event_image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      slug
                      location
                      time
                  }
                  videos {
                      cover_image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      Player_colour
                      createdAt
                      id
                      slug
                      title
                      wisita_id
                  }
                  contacts {
                      email
                      name
                      position
                      Social
                      showBioPage
                      slug
                      image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                  }

                  services {
                      service_image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      service_name
                      slug
                  }
                  projects {
                      Project_name
                      slug
                      Project_content
                      Project_image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                  }
                  withoutlimits {
                      WL_ID
                      authors
                      title
                      OG_image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      slug
                  }
                  articles {
                      createdAt
                      Author
                      title
                      type
                      Sub_message
                      Header_image {
                          childImageSharp {
                              fluid {
                                  base64
                                  tracedSVG
                                  aspectRatio
                                  src
                                  srcSet
                                  srcWebp
                                  srcSetWebp
                                  sizes
                                  originalImg
                                  originalName
                                  presentationWidth
                                  presentationHeight
                              }
                          }
                      }
                      slug
                      createdAt
                  }
          }

          related_content {
              hide_from_menu
              BackgroundColour
              TextColour
              Title
              TitleColour
              Text
              DisplayType
              TileBackgroundColour
              TileTextColour
              TileborderColour
              Tile_text_pacement
              overlayOpacity


              links {
                  image {
                      childImageSharp {
                          fluid(maxWidth: 1920, quality: 80){
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  id
              }
              microsites {
                  Header_background {
                      childImageSharp {
                          fluid(maxWidth: 1920, quality: 80) {
                              base64
                              tracedSVG
                              srcWebp
                              srcSetWebp
                              originalImg
                              originalName
                          }
                      }
                  }
                  logo {
                      publicURL
                      extension
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  site_name
                  site_intro
                  createdAt
                  slug
              }

              podcasts {
                  id
                  podcastid
                  podcasturl
                  title
              }
              events {
                  Event_name
                  date(formatString: "MMMM D, YYYY")
                  event_image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  slug
                  location
                  time
              }
              videos {
                  cover_image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  Player_colour
                  createdAt
                  id
                  slug
                  title
                  wisita_id
              }
              contacts {
                  email
                  name
                  position
                  showBioPage
                  slug
                  Social
                  image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
              }

              services {
                  service_image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  service_name
                  slug
              }
              projects {
                  Project_name
                  slug
                  Project_content
                  Project_image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
              }
              withoutlimits {
                  WL_ID
                  authors
                  title
                  OG_image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  slug
              }
              articles {
                  createdAt
                  Author
                  title
                  type
                  Sub_message
                  Header_image {
                      childImageSharp {
                          fluid {
                              base64
                              tracedSVG
                              aspectRatio
                              src
                              srcSet
                              srcWebp
                              srcSetWebp
                              sizes
                              originalImg
                              originalName
                              presentationWidth
                              presentationHeight
                          }
                      }
                  }
                  slug
                  createdAt
              }



          }

    }

  allStrapiMicrosites(filter: {id: {eq: $MicrositeIDFull}}) {
  edges {
  node {
    pardot_form
    site_description
    MenuTextColor
    HeaderBackgroundColour
    HeaderTitleColour
    overlayOpacity
    site_intro
    site_name
    sub_message
    MainColor
    secondTextColour
    textColor
    secondColor
    Linkedin_conversion_id
    Linkedin_pixel_id
    Content{
      hide_from_menu
      Title
      Type
    }
    download {
      absolutePath
      publicURL
    }

    download_preview {
      childImageSharp {
        fluid {
          base64
          tracedSVG
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
          originalImg
          originalName
          presentationWidth
          presentationHeight
        }
      }
    }
  }
  }
  }




  }
  `
